const comma = s => s ? `, ${s}` : ''

export function processClinicData(pr) {
  
    const {
  
      name, type, service,
  
      latitude, longitude,
  
      line_1, line_2, city, province, country, zip,
      googlePlaceId,
  
      distance, distanceUnit = 'km',
  
      phone = '', fax = '', email = '',eazyscriptsPharmacyId='',
  
      todaysHours = '',
      hoursPerDay = [],
      permanentlyClosed = false, isAlwaysOpen = false, isOpen = false,
  
      placeResult
  
    } = pr
  
    const { result = {} } = pr
    const {
      formatted_address,
      international_phone_number,
      website,
      name: fullName
    } = result
  
    
    let address = result.formatted_address ||
      `${result.line_1}${comma(result.line_2)}${comma(result.city)}${comma(result.province)}${comma(result.zip)}${comma(result.country)}`
    const weekDay = (new Date()).getDay()
  
    return {
      
      name: fullName || name,
      type, service,
  
      latitude, longitude, distance, distanceUnit, googlePlaceId,
  
      address, line_1, line_2, city, province, country, zip, eazyscriptsPharmacyId,
  
      hoursPerDay,
      todaysHours: todaysHours || hoursPerDay[ weekDay ],
  
      phone: international_phone_number || phone,
      email,
      website,
      websiteDomain: !website ? '' : website.split('/')[2], // Works..
  
  
  
  }
  }
